import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import type { RouteIds } from "@tanstack/react-router";
import { QueryClient } from "@tanstack/react-query";
//@ts-ignore
import type { RouterCore, Route, RouteById } from "@tanstack/router-core";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

// Set up a Router instance
export const router = createRouter({
  routeTree,
  scrollRestoration: true,

  context: {
    queryClient,
  },
});

export type RouterType = typeof router;
export type RouterIds = RouteIds<RouterType["routeTree"]>;
export type RouteOptionsById<RouteId extends RouterIds> = Omit<
  RouterType["routesById"][RouteId]["options"],
  "id" | "getParentRoute"
>;
